import type { ReactNode } from 'react';
import happyCalendar from '@/pages/Schedule/assets/happy-calendar-blue.png';
import { Box, Button, Center, Image } from '@/ui';

type Props = {
  children: ReactNode;
  action?: ReactNode;
  cta?: {
    text: ReactNode;
    onClick: () => void;
  };
};

export const EmptyState = ({ children, action, cta }: Props) => {
  const footer =
    action ??
    (cta && (
      <Button variant="secondary" onClick={cta.onClick}>
        {cta.text}
      </Button>
    ));

  return (
    <Center flexDir="column" m="auto" maxW="65%" mt="14">
      <Image src={happyCalendar} w="60%" />
      <Box
        color="customgray.mid"
        fontSize="lg"
        mb={footer ? 8 : 0}
        textAlign="center"
      >
        {children}
      </Box>
      {footer}
    </Center>
  );
};
